import React, { useState, useMemo, createRef, useEffect } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
// Providers
import { DashboardProvider } from '../Dashboard/useDashboard';
// Context
import useProductSamplingContext from './context/useProductSamplingContext';
// Components
import Filter from './components/Filter';
import ProductSamplingDashboardTab from './components/ProductSamplingDashboardTab';
import SdvsrsModal from './components/SdvsrsModal';
import PpsrsModal from './components/PpsrsModal';
import MonthlyTrendModal from './components/MonthlyTrendModal';
// API
import {
  postProductSamplingSdrs,
  postProductSamplingPpsrs,
  postProductSamplingMonthlyTrend,
} from '../../api/productSamplingDashboard';

export default function ProductSamplingDashboard() {
  const productSamplingRef = createRef();
  const defaultFilterForm = {
    is_cpd: true,
    team: { label: 'ALL', value: null },
    product_id: [{ label: 'ALL', value: null }],
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
  };

  const [loading, setLoading] = useState(false);
  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [yearSelected, setYearSelected] = useState(moment().format('YYYY'));
  const [sdvsrsChart, setSdvsrsChart] = useState({
    loading: false,
    data: null,
    total_percentage: 0,
  });

  const [ppsvsrsChart, setPpsvsrsChart] = useState({
    loading: false,
    label: [],
    value: [],
    value1: [],
  });

  const [monthlyTrendChart, setMonthlyTrendChart] = useState({
    loading: false,
    data: null,
  });
  // MODAL
  const [sdvsrsModal, setSdvsrsModal] = useState(false);
  const [ppsvsrsModal, setPpsvsrsModal] = useState(false);
  const [monthlyTrendModal, setMonthlyTrendModal] = useState(false);

  const handleToggleModal = (modal) => {
    if (modal === 'sdvsrs') {
      setSdvsrsModal(true);
    }

    if (modal === 'ppsvsrs') {
      setPpsvsrsModal(true);
    }

    if (modal === 'monthly_trend') {
      setMonthlyTrendModal(true);
    }
  };
  // START HANDLE API FOR CHART //
  const handleSdrsChart = async () => {
    setSdvsrsChart({ ...sdvsrsChart, loading: true });
    const request = {
      team: filterForm?.team?.value,
      products:
        filterForm?.product_id[0].value !== null
          ? filterForm?.product_id?.map((row) => row.value)
          : [],

      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      type: 'graph',
    };

    const response = await postProductSamplingSdrs(request);
    const { code } = response.data;

    if (code === '200') {
      setSdvsrsChart({
        ...sdvsrsChart,
        loading: false,
        data: response?.data?.data,
        total_percentage: response?.data?.total_percentage,
      });
    }
  };

  const handlePpsrsChart = async () => {
    setPpsvsrsChart({ ...ppsvsrsChart, loading: true });
    const request = {
      team: filterForm?.team?.value,
      products:
        filterForm?.product_id[0].value !== null
          ? filterForm?.product_id?.map((row) => row.value)
          : [],

      date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
      type: 'graph',
    };

    const response = await postProductSamplingPpsrs(request);
    const { code, value } = response.data;

    if (code === '200') {
      setPpsvsrsChart({
        ...ppsvsrsChart,
        loading: false,
        label: response?.data?.label,
        value: value[0].data,
        value1: value[1].data,
      });
    }
  };

  const handleMontlyTrendChart = async () => {
    setMonthlyTrendChart({ ...monthlyTrendChart, loading: true });
    const request = {
      team: filterForm?.team?.value,
      products:
        filterForm?.product_id[0].value !== null
          ? filterForm?.product_id?.map((row) => row.value)
          : [],

      year: [Number(yearSelected)],
      type: 'graph',
    };

    const response = await postProductSamplingMonthlyTrend(request);
    const { code } = response.data;
    if (code === '200') {
      setMonthlyTrendChart({ ...monthlyTrendChart, loading: false, data: response?.data?.data });
    }
  };

  // END HANDLE API FOR CHART //

  const handleGenerateFilter = () => {
    handleSdrsChart();
    handlePpsrsChart();
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilterForm);
    productSamplingRef.current.handleClearFilter();
  };

  useEffect(() => {
    handleGenerateFilter();
  }, []);

  useEffect(() => {
    handleMontlyTrendChart();
  }, [yearSelected]);

  return (
    <DashboardProvider>
      <useProductSamplingContext.Provider
        value={useMemo(
          () => ({
            // DATA
            loading,
            filterForm,
            defaultFilterForm,
            sdvsrsChart,
            ppsvsrsChart,
            monthlyTrendChart,
            sdvsrsModal,
            ppsvsrsModal,
            monthlyTrendModal,
            yearSelected,
            // STATE
            setLoading,
            setFilterForm,
            setSdvsrsChart,
            setPpsvsrsChart,
            setMonthlyTrendChart,
            setSdvsrsModal,
            setPpsvsrsModal,
            setMonthlyTrendModal,
            setYearSelected,
            // FUNCTION
            handleToggleModal,
            handleGenerateFilter,
            handleClearFilter,
          }),
          [
            filterForm,
            sdvsrsChart,
            ppsvsrsChart,
            monthlyTrendChart,
            sdvsrsModal,
            ppsvsrsModal,
            monthlyTrendModal,
          ],
        )}
      >
        <Box>
          <Filter />
        </Box>
        <Box mt={5}>
          <ProductSamplingDashboardTab ref={productSamplingRef} />
        </Box>
        {sdvsrsModal ? <SdvsrsModal /> : ''}
        {ppsvsrsModal ? <PpsrsModal /> : ''}
        {monthlyTrendModal ? <MonthlyTrendModal /> : ''}
      </useProductSamplingContext.Provider>
    </DashboardProvider>
  );
}
